// Fetching all documents from the 'roles' collection in Firestore
export const getAllRoles = async ($fire: any) => {
  return await $fire.firestore.collection('roles').get()
}
